import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { CustomerSelectField } from "@/components/carts/NewCartDialog";

export function RenameCartDialog({
  target,
  value,
  onValueChange,
  saving,
  onOpenChange,
  onSubmit,
  customers = null,
  customerId = "none",
  onCustomerChange,
}) {
  return (
    <Dialog open={!!target} onOpenChange={onOpenChange}>
      <DialogContent data-testid="rename-cart-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Edit Quote</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="flex flex-col gap-3">
          <div className="flex flex-col gap-1.5">
            <Label className="text-xs uppercase tracking-[0.05em] text-zinc-500">Quote Name</Label>
            <Input
              value={value}
              onChange={(e) => onValueChange(e.target.value)}
              className="rounded-sm border-zinc-300"
              data-testid="rename-cart-input"
              autoFocus
            />
          </div>
          {customers && (
            <CustomerSelectField
              customers={customers}
              value={customerId}
              onChange={onCustomerChange}
              testId="edit-quote-customer-select"
            />
          )}
          <DialogFooter className="mt-2">
            <Button
              type="submit"
              disabled={saving || !value.trim()}
              className="rounded-sm bg-blue-600 text-white hover:bg-blue-700"
              data-testid="rename-cart-submit-button"
            >
              {saving ? "Saving..." : "Save"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
